import Vue from 'vue/dist/vue.js'

export default Vue.extend({
  data() {
    return {
      value: null,
    }
  },
  created() {
    this.set(this.params)
  },
  methods: {
    refresh(params) {
      this.params = params
      this.set(params)
    },
    set(params) {
      switch (params.value) {
        case -1:
          this.value = 'ALL'
          break
        case 1:
          this.value = 'MON'
          break
        case 2:
          this.value = 'TUE'
          break
        case 3:
          this.value = 'WED'
          break
        case 4:
          this.value = 'THU'
          break
        case 5:
          this.value = 'FRI'
          break
        case 6:
          this.value = 'SAT'
          break
        case 7:
          this.value = 'SUN'
          break
        default:
          break
      }
    },
  },
  template: '<div>{{value}}</div>',
})
